// src/pages/Home/components/Navbar3/data/navbar3.data.js

import {
  FaBookOpen,
  FaBullhorn,
  FaCalendarAlt,
  FaCalendarCheck,
  FaClipboardList,
  FaEnvelope,
  FaFilm,
  FaGavel,
  FaGraduationCap,
  FaIdCard,
  FaInfoCircle,
  FaLandmark,
  FaMapMarkedAlt,
  FaQuestionCircle,
  FaReceipt,
  FaTrophy,
  FaUserCircle,
  FaUserFriends,
  FaUsers,
  FaVideo,
  FaVoteYea,
  FaWeight,
} from "react-icons/fa";

export const ALL_CONNECTED_ROLES = [
  1, 2, 3, 4, 5, 6, 7, 8,
];

export const MESSAGE_ROLES = [
  1, 3, 4, 5, 6, 7, 8,
];

export const ARBITRAGE_ROLES = [
  1, 4, 5,
];

export const CONVOCATION_ROLES = [
  1, 4, 5, 6, 7,
];

export const MENU_SECTIONS = [
  {
    id: "account",
    title: "COMPTE",
    borderClass: "border-blueprimary",
    titleClass: "bg-blueprimary",
    items: [
      {
        label: "Profil & Badges",
        path: "/profile-utilisateur",
        roles: ALL_CONNECTED_ROLES,
        icon: FaUserCircle,
      },
      {
        label: "Messages",
        path: "/messagerie",
        roles: MESSAGE_ROLES,
        icon: FaEnvelope,
        badge: "messages",
      },
      {
        label: "Fiche Acteur Judo",
        path: "/inscription-acteur",
        roles: MESSAGE_ROLES,
        icon: FaIdCard,
      },
      {
        label: "Votre Club",
        path: "/votre-club",
        roles: ALL_CONNECTED_ROLES,
        icon: FaUsers,
      },
    ],
  },
  {
    id: "ligue",
    title: "LIGUE NOUVELLE-AQUITAINE",
    borderClass: "border-green-600",
    titleClass: "bg-green-600",
    items: [
      {
        label: "La Ligue et ses Commissions",
        path: "/commissions-ligue",
        icon: FaLandmark,
      },
      {
        label: "Clubs de Nouvelle Aquitaine",
        path: "/clubs-na",
        icon: FaMapMarkedAlt,
      },
      {
        label: "Formation Dirigeants",
        path: "/formation-dirigeants",
        icon: FaGraduationCap,
      },
      {
        label: "Petites Annonces",
        path: "/petites-annonces",
        icon: FaBullhorn,
      },
    ],
  },
  {
    id: "centre-national",
    title: "LE CENTRE NATIONAL",
    borderClass: "border-purple-600",
    titleClass: "bg-purple-600",
    items: [
      {
        label: "Informations Centre National",
        path: "/infocn",
        icon: FaInfoCircle,
      },
      {
        label: "Inscription cours Centre National",
        path: "/inscriptions-events",
        icon: FaClipboardList,
      },
    ],
  },
  {
    id: "competitions",
    title: "COMPÉTITIONS",
    borderClass: "border-pink-600",
    titleClass: "bg-pink-600",
    items: [
      {
        label: "Calendrier Ligue & Comités",
        path: "/calendrier-ligue",
        icon: FaCalendarAlt,
      },
      {
        label: "Répartitions & Live Video",
        path: "/live-events",
        icon: FaVideo,
      },
      {
        label: "Résultats Compétitions",
        path: "/resultats-calendrier-ligue",
        icon: FaTrophy,
      },
      {
        label: "Catégories d'âge/poids",
        path: "/categories",
        icon: FaWeight,
      },
    ],
  },
  {
    id: "techniques",
    title: "TECHNIQUES",
    borderClass: "border-orange-600",
    titleClass: "bg-orange-600",
    items: [
      {
        label: "Techniques Judo | Kata",
        path: "/techniques-judo",
        icon: FaBookOpen,
      },
      {
        label: "Quizz Techniques",
        path: "/techniques-quizz",
        icon: FaQuestionCircle,
      },
      {
        label: "Recherche Partenaires Kata",
        path: "/partenaires-kata",
        icon: FaUserFriends,
      },
    ],
  },
  {
    id: "arbitrage",
    title: "ARBITRAGE",
    borderClass: "border-yellow-600",
    titleClass: "bg-yellow-600 text-slate-950",
    items: [
      {
        label: "Règlement d'Arbitrage",
        path: "/reglement-arbitrage",
        icon: FaGavel,
      },
      {
        label: "Quizz Vidéo d'Arbitrage",
        path: "/quizz-arbitrage",
        roles: ARBITRAGE_ROLES,
        icon: FaFilm,
      },
      {
        label: "Mes Convocations",
        path: "/mesconvocations",
        roles: CONVOCATION_ROLES,
        icon: FaCalendarCheck,
        badge: "convocations",
      },
      {
        label: "Fiche de Frais",
        path: "/fiche-de-frais",
        roles: CONVOCATION_ROLES,
        icon: FaReceipt,
      },
    ],
  },
  {
    id: "votes",
    title: "VOTES ÉLECTRONIQUES",
    borderClass: "border-blue-900",
    titleClass: "bg-blue-900",
    items: [
      {
        label: "Votes électroniques en cours",
        path: "/votes-utilisateur",
        roles: ALL_CONNECTED_ROLES,
        icon: FaVoteYea,
        badge: "votes",
      },
    ],
  },
];